import React, { useEffect, useState } from "react"
import "../styles/global.scss"
import "../styles/blog.scss"
import MainLayout from "../layouts/MainLayout"
import { Heading1 } from "../components/utils/Typography"
import Breadcrumb from "../components/utils/Breadcrumb"
import { API_WP_GET_ALL_POSTS } from "../api"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function Blog() {
  const [postList, setPostList] = useState([])

  useEffect(() => {
    ;(async () => {
      let l = await API_WP_GET_ALL_POSTS()
      setPostList(l.data.posts)
    })()
  }, [])

  return (
    <div className="blog">
      <MainLayout>
        <Breadcrumb
          arr={[
            { name: "Home", path: "/" },
            { name: "Blog", path: "/blog" },
          ]}
        />
        <Heading1 heading="Blog" subheading="latest articles on tech" />
        <div className="container mt-4 pt-3">
          <div className="row">
            {postList?.map((p, ind) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={ind}>
                <div className="card">
                  <img
                    src={
                      p.featured_image !== ""
                        ? p.featured_image
                        : "https://via.placeholder.com/300x150?text=No+Image"
                    }
                    className="card-img-top img-fluid"
                    alt=""
                  />
                  <div className="card-body">
                    <h5 className="card-title">{p.title}</h5>
                    <small>
                      By {p.author.first_name + " " + p.author.last_name}
                    </small>
                    <br />
                    <AniLink
                      paintDrip
                      hex="#551864"
                      to={`/blog/post/${p.ID}`}
                      className="btn btn-primary mt-3"
                    >
                      Read More
                    </AniLink>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </MainLayout>
    </div>
  )
}

export default Blog
